import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsBespokeCommunityCreateEditEnabled = () => boolean;
export const useIsBespokeCommunityCreateEditEnabled: UseIsBespokeCommunityCreateEditEnabled = () =>
  useExperimentTreatmentWithoutReporting(Experiment.BespokeCommunityCreateEdit) === true;
